<template>
  <v-container class="text-center d-flex flex-column justify-center align-center">
    <BaseTitle class="mt-2">Préinscription effectuée</BaseTitle>
    <BaseParagraph class="mt-10 mx-6">
      <strong>Votre inscription a bien été prise en compte</strong>,
      vous allez recevoir un email afin que nous puissions confirmer votre adresse email.
      <br>
      Veuillez cliquer sur le lien présent dans l'email.
    </BaseParagraph>
    <v-img class="mt-16 mb-3 mx-12" width="60%" src="@/assets/done.svg" />
    <BaseButton outlined to="/">Revenir à l'accueil</BaseButton>
  </v-container>
</template>

<script>
import BaseParagraph from '@/components/BaseParagraph.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'SignUpSuccess',
  components: {
    BaseParagraph,
    BaseButton,
    BaseTitle,
  },
};
</script>
